<template>
  <div  class="wrap" :style="cssPosition" ref="wrap" >
    <div class="header" ref="widgetHeader">
      <!-- Режим просмотра -->
      <div v-if="!editable" class="full_header">
        <v-row dense align="center" no-gutters>
          <v-col>
              <v-tooltip bottom max-width="400">
                <template #activator="{ on }">
                  <v-btn small v-on="on" icon style="cursor: default;">
                    <v-icon color="info" small>mdi-information-variant</v-icon>
                  </v-btn>
                </template>
                <span v-html="paramsHint"></span>
              </v-tooltip>

              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn small v-on="on" icon style="cursor: default;">
                    <v-icon color="info" small>mdi-help</v-icon>
                  </v-btn>
                </template>
                <span v-html="options.hint"></span>
              </v-tooltip>
            
              <v-tooltip bottom v-if="'views' in options && options.views.length > 1">
                <template #activator="{ on }">
                  <v-btn v-on="on" small icon @click="changeView">
                    <v-icon color="info" class="ml-2">{{ viewIcon }}</v-icon>
                  </v-btn>
                </template>
                <span>Сменить Вид</span>
              </v-tooltip>
              <span
                class="widget_name ml-4"
                :title="options.name"
              >{{ options.name.toUpperCase() }}</span>
            
          </v-col>
        </v-row>
      </div>

      <!-- Режим редактирования -->
      <div 
        v-else 
        class="full_header"
      >
        <v-row dense align="center" no-gutters>
          <v-col cols="auto">
            <v-tooltip bottom max-width="400">
              <template #activator="{ on }">
                <v-btn small v-on="on" icon style="cursor: default;">
                  <v-icon color="info" small>mdi-information-variant</v-icon>
                </v-btn>
              </template>
              <span v-html="paramsHint"></span>
            </v-tooltip>
          </v-col>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn v-on="on" small icon style="cursor: default;">
                  <v-icon color="info" small>mdi-help</v-icon>
                </v-btn>
              </template>
              <span v-html="options.hint"></span>
            </v-tooltip>
          </v-col>
          <v-col cols="auto" v-if="'views' in options && options.views.length > 1">
            <v-tooltip bottom>
              <template #activator="{ on }">

                <span v-for="(view, index) in options.views" v-on="on" :key="`viewbtn${index}`">
                  <v-btn v-if="view === options.currentView" small icon @click="changeView">
                    <v-icon color="info">{{ viewIcon }}</v-icon>
                  </v-btn>
                </span>

              </template>
              <span>Сменить вид</span>
            </v-tooltip>
          </v-col>
          
          <v-col 
            @mousedown="isClicked = true"
            class="text-center header-label"
            :title="options.name"
          >{{ options.name.toUpperCase() }}</v-col>

          <v-col cols="auto" v-if="!noSettings">
            <v-btn small icon @click="openEditWidget">
              <v-icon color="warning">mdi-cog</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <v-btn small icon @click="closeWidget">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="body" ref="widgetBody">
      <slot></slot>
    </div>

    <span 
      v-if="editable"
      class="stretch_br"
      @mousedown="isStretchClicked = true"
    >
      <v-icon class="mdi-rotate-315">mdi-arrow-expand-down</v-icon> 
    </span>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WidgetWrap',

  props: {
    options: Object,
    editable: Boolean,
    noSettings: Boolean,
  },
  data() {
    return {
      isClicked: false,
      isStretchClicked: false,
      headerCursor: 'grab',
      bgClr: '',
      paramsHint: '',

      view: true,
    }
  },

  computed: {
    ...mapGetters({
      dashboard: 'dashboard/dashboard',
      allGroups: 'graphql/allGroups',
      allProjects: 'graphql/allProjects',
    }),
    cssPosition() {
      return {
        left: `${this.options.position.x}px`,
        top: `${this.options.position.y}px`,
        width: `${this.options.position.width}px`,
        height: `${this.options.position.height}px`,
        zIndex: this.isClicked ? '999' : '',
        background: this.bgClr,
        opacity: this.isClicked ? '0.8' : '1',
      }
    },

    viewIcon() {
      if (!('currentView' in this.options)) return ''
      switch (this.options.currentView.slice(0, -1)) {
        case 'table':
          return 'mdi-chart-line'
        case 'graph':
          return 'mdi-table'
      
        default:
          return ''
      }
    },

    isDark() {
      return this.$vuetify.theme.isDark
    },
  },
  
  watch: {
    isClicked(val) {
      if (val) document.body.style.cursor = 'move';
      else document.body.style.cursor = 'default';
    },

    editable() {
      this.changeBodyHeight()
    },

    isDark(val) {
      val ? this.bgClr = 'linear-gradient(60deg, hsl(0, 0%, 14%), hsl(0, 0%, 24%))' : this.bgClr = 'linear-gradient(120deg, hsl(0, 0%, 95%), hsl(0, 0%, 83%))'
    },
  },

  methods: {
    changeView() {
      if (!('currentView' in this.options)) return
      let index = this.options.views.findIndex(v => v === this.options.currentView)
      this.options.currentView = this.options.views[index + 1] ?? this.options.views[0]
    },

    openEditWidget() {
      this.$emit('change:openEdit', true)
    },

    changeBodyHeight() {
      setTimeout(() => {
        let headerHeight = this.$refs.widgetHeader.getBoundingClientRect().height
        this.$refs.widgetBody.style.setProperty('--header-height', headerHeight)
      }, 50)
    },

    closeWidget() {
      let index = this.dashboard.widgets.findIndex(w => w.id === this.options.id)
      this.dashboard.widgets.splice(index, 1)
    },

    getParamsHint() {
      let html = ''
      let translateName = {
        TableSl: 'Таблица SL',
        EmploymentWidget: 'Занятость',
        AcceptedMissed: 'Принятые/Пропущенные',
        GroupByOperator: 'Вызовы по операторам',
        HourlyDynamics: 'Почасовая динамика',
        ExtendedCall: 'Информация по вызовам',
        OksReport: 'Окс отчёт',
        AvgAgentTime: 'Вызовы по дням',
        TransferWidget: 'Переведённые вызовы',
        ForecastCalls: 'Прогноз вызовов по дням',
        OutgoingCalls: 'Информация по исходящим вызовам',
        OutgoingByOperators: 'Исходящие по операторам',
        StatisticByOperators: 'Статистика по операторам',
        VuelinerTable: 'Мониторинг звонков',
        StatisticByQueues: 'Статистика по очередям',
        OperatorCampaignStatiscticByDays: 'Разбивка операторов по Кампаниям',
        PercentageAcceptByCampaign: 'Процент принятых по кампаниям',
      }

      let spanStart = '<span style="color: hsl(134, 61%, 70%)">'
      let spanEnd = '</span>'

      html += `<b>${translateName[this.options.type]}</b><br>`

      let periodsTranslate = {
        today: 'сегодня',
        yesterday: 'вчера',
        currWeek: 'текущая неделя',
        prevWeek: 'предыдущая неделя',
        currMonth: 'текущий месяц',
        prevMonth: 'предыдущий месяц',
      }

      if ('period' in this.options.params) {
        html += `${spanStart}Период:${spanEnd} ${periodsTranslate[this.options.params.period]}`
        html += '<br>'
      }

      if ('groups' in this.options.params) {
        let pGroups = this.options.params.groups

        if (pGroups.length > 0) {
          html += `${spanStart}Группы:${spanEnd} `
          pGroups.forEach(id => {
            let group = this.allGroups.find(group => group.id === id)
            if (!group) return

            html += group.name + ', '
          })

          if (html.endsWith(', ')) html = html.replace(/, $/, '')
        }
        html += '<br>'
      }

      if (
        'projects' in this.options.params ||
        'projectsSingle' in this.options.params
      ) {
        let pProjects = this.options.params?.projects || this.options.params.projectsSingle

        if (pProjects.length > 0) {
          html += `${spanStart}Проекты:${spanEnd} `
          pProjects.forEach(id => {
            let project = this.allProjects.find(project => project.id === id)
            if (!project) return

            html += project.name + ', '
          })

          if (html.endsWith(', ')) html = html.replace(/, $/, '')
          html += '<br>'
        }

        if (this.options.params.isAllProjects) {
          html += spanStart + 'Все проекты' + spanEnd
          html += '<br>'
        }
      }

      this.paramsHint = html
    },

  },

  mounted() {
    this.isDark ? this.bgClr = 'linear-gradient(60deg, hsl(0, 0%, 14%), hsl(0, 0%, 24%))' : this.bgClr = 'linear-gradient(120deg, hsl(0, 0%, 95%), hsl(0, 0%, 83%))'

    let canvas = document.querySelector('#canvas-wrap')

    this.changeBodyHeight()

    window.addEventListener('mouseup', () => {
      this.isClicked = false
      this.isStretchClicked = false
    })

    window.addEventListener('mousemove', (ev) => {
      if (!this.isClicked) return

      // left border
      if (this.options.position.x < 4) {
        this.options.position.x = 5
      } else if (this.options.position.x > 5) {
        this.options.position.x += ev.movementX
      } else if (ev.movementX > 0) {
        this.options.position.x += ev.movementX
      }

      // top border
      if (this.options.position.y < 4) {
        this.options.position.y = 5
      }else if (this.options.position.y > 5) {
        this.options.position.y += ev.movementY
      } else if (ev.movementY > 0) {
        this.options.position.y += ev.movementY
      }
    })
    
    canvas.addEventListener('mousemove', (ev) => {
      if (!this.isStretchClicked) return

      if (this.options.position.width < this.options.position.min_width) {
        this.options.position.width = this.options.position.min_width
        this.options.position.height += ev.movementY
      } else if (this.options.position.width > this.options.position.max_width) {
        this.options.position.width = this.options.position.max_width
        this.options.position.height += ev.movementY
      } else if (this.options.position.height < this.options.position.min_height) {
        this.options.position.height = this.options.position.min_height
        this.options.position.width += ev.movementX
      } else if (this.options.position.height > this.options.position.max_height) {
        this.options.position.height = this.options.position.max_height
        this.options.position.width += ev.movementX
      } else {
        this.options.position.width += ev.movementX
        this.options.position.height += ev.movementY
      }
    })

    this.getParamsHint()
  },

}
</script>


<style scoped lang="scss">
$border-color: #E0E0E054;
.wrap {
  position: absolute;
  border: 1px solid #6d6d6d4f;
  border-radius: 0.7rem;
  box-shadow: 0 0 7px #6d6d6d;
  padding: 0.5em;
}

.stretch_br {
  position: absolute;
  right: 1px;
  bottom: 1px;
  cursor: pointer;

  &:hover >* {
    color: rgb(36, 189, 105);
  }
}

.stretchside {
  $width: 6px;
  $position: -2px;
  
  position: absolute;
  display: block;
  background-color: #2196F3;
  cursor: col-resize;

  &.top {
    top: $position;
    height: $width;
    width: 100%;
    cursor: row-resize;
  }
  &.right {
    right: $position;
    width: $width;
    height: 100%;
  }
  &.bottom {
    bottom: $position;
    height: $width;
    width: 100%;
    cursor: row-resize;
  }
  &.left {
    left: $position;
    width: $width;
    height: 100%;
  }
}

.header-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
	font-weight: bold;
	letter-spacing: 2px;
  cursor: move;
}

.widget_name {
	font-size: 0.75rem;
	font-weight: bold;
  line-height: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 80%;
	display: inline-block;
}

.full_header {
  // height: 50px;
  border-bottom: 1px solid $border-color;
  user-select: none;
}

.body {
  width: 100%;
  height: 30%;
  min-height: calc(100% - var(--header-height, 50) * 1px);
  overflow: hidden;
}

.footer {
  position: absolute;
  bottom: 15px;
}
</style>


<style>
.apex-hidden-scrollbar [id^="apexcharts"] {
  overflow: hidden !important;
}
</style>